/**
 * LeverageStoreLoader - previously loaded user leverages from /user/leverages API
 * This API endpoint has been removed. Leverage is now managed locally or via positions API.
 */
export const LeverageStoreLoader = () => {
  return null;
};
